(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProClaimConf', ProClaimConf);

    ProClaimConf.$inject = ['$resource'];

    function ProClaimConf ($resource) {
        var resourceUrl =  'api/pro-claim-confs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'create': {url: 'api/pro-claim-confs/create', method: 'POST', isArray: false},
            'filter': {url: 'api/pro-claim-confs/filter', method: 'GET', isArray: true},
            'lastsModifiersUsedByFacility': {url: 'api/diagnoses/lasts-modifiers-used-by-facility', method: 'GET', isArray: true},
        });
    }
})();
